/* Hydromax PDP — Interaktionen: Countdown, Galerie, Akkordeons, Sticky-ATC, Bundles */
(function () {
  'use strict';
  if (window.__pdpInit) return;
  window.__pdpInit = true;

  /* ---- Akkordeons (Produkt-Infos + FAQ) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-pinfo button, .pdp-faq button');
    if (!btn) return;
    var item = btn.closest('.it');
    if (item) item.classList.toggle('open');
  });

  /* ---- Galerie: Thumbnail -> Hauptbild ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-thumbs .row img');
    if (!thumb) return;
    var gallery = thumb.closest('.pdp-gallery');
    if (!gallery) return;
    var main = gallery.querySelector('.pdp-frame img');
    if (main) {
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-full') || thumb.getAttribute('src');
    }
    gallery.querySelectorAll('.pdp-thumbs .row img').forEach(function (i) { i.classList.remove('active'); });
    thumb.classList.add('active');
  });
  document.addEventListener('click', function (e) {
    var arw = e.target.closest('.pdp-thumbs .arw');
    if (!arw) return;
    var row = arw.parentElement.querySelector('.row');
    if (row) row.scrollBy({ left: (arw.dataset.dir === 'prev' ? -1 : 1) * 180, behavior: 'smooth' });
  });

  /* ---- Bundle-/Varianten-Auswahl ---- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('.pdp-bundle input[type=radio]')) return;
    var buy = input.closest('.pdp-buy');
    if (!buy) return;
    buy.querySelectorAll('.pdp-bundle').forEach(function (b) { b.classList.remove('sel'); });
    var card = input.closest('.pdp-bundle');
    if (card) card.classList.add('sel');
    // Die Radios sind name="id" -> die aktive Variante wird direkt mit dem Formular gesendet.
    // Nur den Sticky-Preis spiegeln:
    var price = input.dataset.price || '';
    var sticky = document.querySelector('.pdp-atcbar .pdp-atc-price');
    if (sticky && price) sticky.textContent = price;
  });

  /* ---- Sticky ATC-Bar beim Scrollen ---- */
  var atc = document.querySelector('.pdp-atcbar');
  if (atc) {
    var onScroll = function () { atc.classList.toggle('show', window.scrollY > 720); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Countdown ---- */
  function initCountdowns() {
    document.querySelectorAll('.pdp-cd[data-seconds]').forEach(function (cd) {
      if (cd._pdpInit) return;
      cd._pdpInit = true;
      var remaining = parseInt(cd.getAttribute('data-seconds'), 10) || 0;
      var h = cd.querySelector('[data-h]'), m = cd.querySelector('[data-m]'), s = cd.querySelector('[data-s]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        if (remaining > 0) remaining--;
        var hh = Math.floor(remaining / 3600), mm = Math.floor((remaining % 3600) / 60), ss = remaining % 60;
        if (h) h.textContent = pad(hh);
        if (m) m.textContent = pad(mm);
        if (s) s.textContent = pad(ss);
      };
      tick();
      setInterval(tick, 1000);
    });
  }
  if (document.readyState !== 'loading') initCountdowns();
  else document.addEventListener('DOMContentLoaded', initCountdowns);
  document.addEventListener('shopify:section:load', initCountdowns);
})();
